// eslint-disable-next-line import/prefer-default-export
import { COOKIES_NAME_PREFIX } from '@/store/tokens.constants';

export default function buildId(idCotacao, prefix = 'SOLICITACAO') {
  return `${prefix}_${COOKIES_NAME_PREFIX}${idCotacao}`;
}
